import { useEvent } from "effector-react/scope";
import s from "./styles.module.sass";
import Input, { InputProps } from "@components/UI/Input";
import TextArea from "@components/UI/TextArea";
import Button from "@components/UI/Button";
import InputWithMask from "@components/UI/InputWithMask";
import { phoneFormatInput } from "@shared/constants/masks";
import NextLink from "@shared/wrappers/NextLink";
import {
	$formFields,
	$formValidationErrors,
	handleFormSubmit,
	updateFormField,
	updateFormPhoneField,
} from "../model/private";
import { useStore } from "effector-react";
import "../model/init";
import { FormEvent } from "react";
import { DOCUMENT_LINKS } from "../../../constants/DOCUMENTS_LINKS";

export const FeedBackForm = () => {
	const formFields = useStore($formFields);
	const formValidationErrors = useStore($formValidationErrors);

	const onChangeFormField = useEvent(updateFormField);
	const onChangePhoneFormField = useEvent(updateFormPhoneField);
	const submitForm = useEvent(handleFormSubmit);

	const isSubmitButtonDisabled = formFields.question.length < 10 || formFields.phone.length === 11;

	const handleSubmitForm = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();

		submitForm(formFields);
	};

	const phoneInputProps: InputProps = {
		label: "Телефон",
		name: "phone",
		error: formValidationErrors?.phone,
		color: "secondary",
	};

	return (
		<div className={s.wrapper}>
			<div className={s.info}>
				<h2 className={s.title}>Связаться с нами</h2>
				<p>Специалисты Selfschool ответят на любые вопросы, связанные с платформой.</p>
			</div>

			<form className={s.contactsForm} onSubmit={handleSubmitForm}>
				<Input
					label="Ваше имя"
					value={formFields.name}
					name={"name"}
					error={formValidationErrors?.name}
					onChange={(e) => {
						return onChangeFormField({
							event: e,
							field: "name",
						});
					}}
					color="secondary"
				/>
				<div className={s.userContacts}>
					<InputWithMask
						inputProps={phoneInputProps}
						maskProps={{
							...phoneFormatInput,
							onValueChange: (values) => {
								return onChangePhoneFormField(values.formattedValue);
							},
							name: "phone",
							value: formFields.phone,
						}}
					/>
					<Input
						label="Email"
						value={formFields.email}
						error={formValidationErrors?.email}
						onChange={(e) => {
							return onChangeFormField({
								event: e,
								field: "email",
							});
						}}
						color="secondary"
					/>
				</div>
				<TextArea
					label="Ваш вопрос"
					value={formFields.question}
					minLength={10}
					onChange={(e) => {
						return onChangeFormField({
							event: e,
							field: "question",
						});
					}}
					labelClassName={s.label}
					color="secondary"
				/>
				<p className={s.privacyPolicyNote}>
					Отправляя вопрос, я{" "}
					<NextLink href={DOCUMENT_LINKS.PERSONAL_DATA_AGREEMENT}>
						<u>даю согласие на обработку моих персональных данных</u>
					</NextLink>{" "}
					в соответствии с условиями{" "}
					<NextLink href={DOCUMENT_LINKS.PRIVACY_URL}>
						<u>Политики обработки персональных данных в Selfschool</u>
					</NextLink>
				</p>
				<Button
					text="Отправить вопрос"
					fullWidth
					variant="secondary_filled"
					type="submit"
					disabled={isSubmitButtonDisabled}
					upperCase
				/>
			</form>
		</div>
	);
};
